(() => {
  document.querySelectorAll('[data-nav-toggle]').forEach((toggle) => {
    const nav = toggle.closest('.site-header')?.querySelector('[data-nav]');
    if (!nav) return;
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  const revealItems = document.querySelectorAll(
    '.journey__intro, .guide-card, .why-card, .series-card, .about-diane, .resources, .journal-panel, .newsletter, .error-404__inner, .shop-page__inner'
  );

  revealItems.forEach((el, index) => {
    el.classList.add('reveal');
    el.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 70}ms`);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
  );

  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
})();
